var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"field-sort fa",class:{ 'fa-sort': _vm.field.sort_default, 'fa-sort-asc': _vm.field.sort_asc, 'fa-sort-desc': _vm.field.sort_desc },attrs:{"id":_vm.field.id},on:{"click":function($event){_vm.actionSort($event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4517765e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/general/fields/sort/template.pug
// module id = lcrp
// module chunks = 1